<template>
  <div id="info">
    <van-nav-bar
      title="证件信息"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      style="margin-bottom: 20px;"
    />
    <van-form>
      <div style="text-align: left;padding-left: 20px;">电工证</div>
      <div style="overflow: hidden; margin-top: 10px;">
        <div style="float: left; width: 50%">
          <div style="text-align: center">正面</div>
          <div style="margin: 5px auto; width: 60%;">
            <van-field name="uploader" title="">
              <template #input>
                <van-uploader v-model="postForm.ele_front_img" :max-size="maxSize" :before-read="beforeRead" :after-read="file => onRead(file, 'ele_front')" :before-delete="file => deleteFile(file, 'ele_front')" :max-count="1" @oversize="onOversize"/>
              </template>
            </van-field>
          </div>
        </div>
        <div style="float: left; width: 50%">
          <div style="text-align: center">反面</div>
          <div style="margin: 5px auto; width: 60%;">
            <van-field name="uploader" title="">
              <template #input>
                <van-uploader v-model="postForm.ele_back_img" :max-size="maxSize" :before-read="beforeRead" :after-read="file => onRead(file, 'ele_back')" :before-delete="file => deleteFile(file, 'ele_back')" :max-count="1" @oversize="onOversize"/>
              </template>
            </van-field>
          </div>
        </div>
      </div>
      <div style="text-align: left;padding-left: 20px;">制冷证</div>
      <div style="overflow: hidden; margin-top: 10px;">
        <div style="float: left; width: 50%">
          <div style="text-align: center">正面</div>
          <div style="margin: 5px auto; width: 60%;">
            <van-field name="uploader" title="">
              <template #input>
                <van-uploader v-model="postForm.cold_front_img" :max-size="maxSize" :before-read="beforeRead" :after-read="file => onRead(file, 'cold_front')" :before-delete="file => deleteFile(file, 'cold_front')" :max-count="1" @oversize="onOversize"/>
              </template>
            </van-field>
          </div>
        </div>
        <div style="float: left; width: 50%">
          <div style="text-align: center">反面</div>
          <div style="margin: 5px auto; width: 60%;">
            <van-field name="uploader" title="">
              <template #input>
                <van-uploader v-model="postForm.cold_back_img" :max-size="maxSize" :before-read="beforeRead" :after-read="file => onRead(file, 'cold_back')" :before-delete="file => deleteFile(file, 'cold_back')" :max-count="1" @oversize="onOversize"/>
              </template>
            </van-field>
          </div>
        </div>
      </div>
      <div style="text-align: left;padding-left: 20px;">高空证</div>
      <div style="overflow: hidden; margin-top: 10px;">
        <div style="float: left; width: 50%">
          <div style="text-align: center">正面</div>
          <div style="margin: 5px auto; width: 60%;">
            <van-field name="uploader" title="">
              <template #input>
                <van-uploader v-model="postForm.high_front_img" :max-size="maxSize" :before-read="beforeRead" :after-read="file => onRead(file, 'high_front')" :before-delete="file => deleteFile(file, 'high_front')" :max-count="1" @oversize="onOversize"/>
              </template>
            </van-field>
          </div>
        </div>
        <div style="float: left; width: 50%">
          <div style="text-align: center">反面</div>
          <div style="margin: 5px auto; width: 60%;">
            <van-field name="uploader" title="">
              <template #input>
                <van-uploader v-model="postForm.high_back_img" :max-size="maxSize" :before-read="beforeRead" :after-read="file => onRead(file, 'high_back')" :before-delete="file => deleteFile(file, 'high_back')" :max-count="1" @oversize="onOversize"/>
              </template>
            </van-field>
          </div>
        </div>
      </div>
      <div style="text-align: left;padding-left: 20px;">焊工证</div>
      <div style="overflow: hidden; margin-top: 10px;">
        <div style="float: left; width: 50%">
          <div style="text-align: center">正面</div>
          <div style="margin: 5px auto; width: 60%;">
            <van-field name="uploader" title="">
              <template #input>
                <van-uploader v-model="postForm.hg_front_img" :max-size="maxSize" :before-read="beforeRead" :after-read="file => onRead(file, 'hg_front')" :before-delete="file => deleteFile(file, 'hg_front')" :max-count="1" @oversize="onOversize"/>
              </template>
            </van-field>
          </div>
        </div>
        <div style="float: left; width: 50%">
          <div style="text-align: center">反面</div>
          <div style="margin: 5px auto; width: 60%;">
            <van-field name="uploader" title="">
              <template #input>
                <van-uploader v-model="postForm.hg_back_img" :max-size="maxSize" :before-read="beforeRead" :after-read="file => onRead(file, 'hg_back')" :before-delete="file => deleteFile(file, 'hg_back')" :max-count="1" @oversize="onOversize"/>
              </template>
            </van-field>
          </div>
        </div>
      </div>
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit" @click="onSubmit">提交</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import {Toast} from 'vant'
import {getManInfo, updateManInfo} from '@/api/user'
import Uploader from './uploader'
import {getOssToken} from "../../../api/order";
import OSS from "ali-oss";
import {getFileRealPath} from "../../../api/util";

export default {
  name: 'info',
  components: {
    Uploader
  },
  data () {
    return {
      maxSize: 40960 * 1024,
      postForm: {
        name: '',
        id_card: '',
        ele_front_img: [],
        ele_back_img: [],
        cold_front_img: [],
        cold_back_img: [],
        high_front_img: [],
        high_back_img: [],
        hg_front_img: [],
        hg_back_img: [],
      },
      imageList: [],
      activeNames: ['1'],
    }
  },
  created() {
    this.initUserInfo()
  },
  methods: {
    async initUserInfo() {
      await getManInfo().then((res) => {
        if (res.data.data) {
          this.postForm.name = res.data.data && res.data.data.worker_name
          const details = res.data.data && res.data.data.certificate_list
          if (details.electrician_certificate) {
            this.postForm.ele_certificate_id = details.electrician_certificate.certificate_id
            this.postForm.ele_front = details.electrician_certificate.img_front.file_id
            this.postForm.ele_front_img = [{
              url: details.electrician_certificate.img_front.file_url_thumb,
              status: ''
            }]
            this.postForm.ele_back = details.electrician_certificate.img_front.file_id
            this.postForm.ele_back_img = [{
              url: details.electrician_certificate.img_back.file_url_thumb,
              status: ''
            }]
          }
          if (details.welder_certificate) {
            this.postForm.hg_certificate_id = details.welder_certificate.certificate_id
            this.postForm.hg_front = details.welder_certificate.img_front.file_id
            this.postForm.hg_front_img = [
              {
                url: details.welder_certificate.img_front.file_url_thumb,
                status: ''
              }
            ]
            this.postForm.hg_back = details.welder_certificate.img_back.file_id
            this.postForm.hg_back_img = [
              {
                url: details.welder_certificate.img_back.file_url_thumb,
                status: ''
              }
            ]
          }
          if (details.refrigeration_certificate) {
            this.postForm.cold_certificate_id = details.refrigeration_certificate.certificate_id
            this.postForm.cold_front = details.refrigeration_certificate.img_front.file_id
            this.postForm.cold_front_img = [{
              url: details.refrigeration_certificate.img_front.file_url_thumb,
              status: ''
            }]
            this.postForm.cold_back = details.refrigeration_certificate.img_back.file_id
            this.postForm.cold_back_img = [{
              url: details.refrigeration_certificate.img_back.file_url_thumb,
              status: ''
            }]
          }
          if (details.high_altitude_certificate) {
            this.postForm.high_certificate_id = details.high_altitude_certificate.certificate_id
            this.postForm.high_front = details.high_altitude_certificate.img_front.file_id
            this.postForm.high_front_img = [{
              url: details.high_altitude_certificate.img_front.file_url_thumb,
              status: ''
            }]
            this.postForm.high_back = details.high_altitude_certificate.img_back.file_id
            this.postForm.high_back_img = [{
              url: details.high_altitude_certificate.img_back.file_url_thumb,
              status: ''
            }]
          }
          this.$forceUpdate()
          console.log('fjkdslfjsladflsalfsdlflsll2222222', this.postForm)
        }
      })
    },
    onOversize() {

    },
    onClickLeft() {
      this.$router.push('/my')
    },
    beforeRead (file) {
      if (file.length > 1) {
        for (const i in file) {
          if (file[i].type !== 'image/jpeg' && file[i].type !== 'image/png' && file[i].type !== 'image/jpg') {
            Toast('请上传图片')
            return false
          }
        }
      } else {
        if (file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/jpg') {
          Toast('请上传图片')
          return false
        }
      }
      return true
    },
    deleteFile(file, index) {
      if (index === 'ele_front') {
        this.postForm.ele_front = ''
        this.postForm.ele_front_img = []
      }
      if (index === 'ele_back') {
        this.postForm.ele_back = ''
        this.postForm.ele_back_img = []
      }
      if (index === 'cold_front') {
        this.postForm.cold_front = ''
        this.postForm.cold_front_img = []
      }
      if (index === 'cold_back') {
        this.postForm.cold_back = ''
        this.postForm.cold_back_img = []
      }
      if (index === 'high_front') {
        this.postForm.high_front = ''
        this.postForm.high_front_img = []
      }
      if (index === 'high_back') {
        this.postForm.high_back = ''
        this.postForm.high_back_img = []
      }
      if (index === 'hg_front') {
        this.postForm.hg_front = ''
        this.postForm.hg_front_img = []
      }
      if (index === 'hg_back') {
        this.postForm.hg_back = ''
        this.postForm.hg_back_img = []
      }
    },
    onRead(file, index) {
      this.uploadImg(file.file, index)
    },
    async uploadImg(file, index) {
      let fileSuffix = ''
      if (file.type === 'image/jpeg') {
        fileSuffix = 'jpeg'
      }
      if (file.type === 'image/png') {
        fileSuffix = 'png'
      }
      if (file.type === 'image/jpg') {
        fileSuffix = 'jpg'
      }
      console.log('fjklsdfkljsflsl')
      await getOssToken({file_suffix: fileSuffix}).then((res) => {
        if (res.data.data) {
          const ossData = res.data.data
          const client = new OSS({
            region: 'oss-' + ossData.region_id,
            accessKeySecret: ossData.access_secret,
            accessKeyId: ossData.access_id,
            stsToken: ossData.secret_token,
            bucket: ossData.bucket
          })
          client.put(ossData.file_name, file).then((result) => {
            if (result && result.url) {
              getFileRealPath({file_id: ossData.file_id}).then((res) => {
                if (res.data.data && res.data.data.file_url_original) {
                  const filePath = [
                    {
                      url: res.data.data.file_url_original,
                      status: '',
                      id: ossData.file_id,
                      name: ossData.file_name
                    }
                  ]
                  if (index === 'ele_front') {
                    this.postForm.ele_front = ossData.file_id
                    this.postForm.ele_front_img = filePath
                  }
                  if (index === 'ele_back') {
                    this.postForm.ele_back = ossData.file_id
                    this.postForm.ele_back_img = filePath
                  }
                  if (index === 'cold_front') {
                    this.postForm.cold_front = ossData.file_id
                    this.postForm.cold_front_img = filePath
                  }
                  if (index === 'cold_back') {
                    this.postForm.cold_back = ossData.file_id
                    this.postForm.cold_back_img = filePath
                  }
                  if (index === 'high_front') {
                    this.postForm.high_front = ossData.file_id
                    this.postForm.high_front_img = filePath
                  }
                  if (index === 'high_back') {
                    this.postForm.high_back = ossData.file_id
                    this.postForm.high_back_img = filePath
                  }
                  if (index === 'hg_front') {
                    this.postForm.hg_front = ossData.file_id
                    this.postForm.hg_front_img = filePath
                  }
                  if (index === 'hg_back') {
                    this.postForm.hg_back = ossData.file_id
                    this.postForm.hg_back_img = filePath
                  }
                  console.log('jflskadfjklasflkdsalfds', this.postForm)
                  this.$forceUpdate()
                }
              })

            }
          })
        }
      })
    },
    forwardLogin() {
      this.$router.push({path: '/'})
    },
    async onSubmit() {
      /*if (this.postForm.name === '' || typeof this.postForm.name === 'undefined') {
        Toast('姓名不能为空');
        return false;
      }*/
      const electrician_certificate = {
        certificate_type: 'electrician_certificate',
        info:
          {
            img_front: this.postForm.ele_front,
            img_back: this.postForm.ele_back
          }
      }
      if (this.postForm.ele_certificate_id) {
        electrician_certificate.certificate_id = this.postForm.id_certificate_id
      }

      const updateEleResult = await updateManInfo(electrician_certificate)

      const bankInfo = {
        certificate_type: 'refrigeration_certificate',
        info:
          {
            img_front: this.postForm.cold_front,
            img_back: this.postForm.cold_back
          }
      }

      if (this.postForm.cold_certificate_id) {
        bankInfo.certificate_id = this.postForm.cold_certificate_id
      }

      const updateBankResult = await updateManInfo(bankInfo)

      const HighInfo = {
        certificate_type: 'high_altitude_certificate',
        info:
          {
            img_front: this.postForm.high_front,
            img_back: this.postForm.high_back
          }
      }

      if (this.postForm.high_certificate_id) {
        HighInfo.certificate_id = this.postForm.high_certificate_id
      }

      const updateHighResult = await updateManInfo(HighInfo)

      const hgInfo = {
        certificate_type: 'welder_certificate',
        info:
          {
            img_front: this.postForm.hg_front,
            img_back: this.postForm.hg_back
          }
      }

      if (this.postForm.bank_certificate_id) {
        bankInfo.certificate_id = this.postForm.bank_certificate_id
      }

      const updateHgResult = await updateManInfo(hgInfo)

      setTimeout(() => {
        Toast('提交成功')
        this.$router.push('/my')
      }, 2000)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/components/certificates.vue